/**
 * Created by shubham on 29/4/18.
 */

import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { Http} from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MultiApproveRejectComponent } from '../multi-approve-reject/multi-approve-reject.component';
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import { APPCONFIG } from '../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+APPCONFIG.translationUrl, '?v='+APPCONFIG.translationVersion),
            deps: [Http]
        })
    ],
    declarations: [
        MultiApproveRejectComponent
    ],
    exports: [
        MultiApproveRejectComponent,
    ]
})

export class MultiApproveRejectRequestModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/multi-approve-reject/multi-approve-reject-request.module.ts